import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-homeone-about',
    templateUrl: './homeone-about.component.html',
    styleUrls: ['./homeone-about.component.scss']
})
export class HomeoneAboutComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    aboutImage: Image[] = [
        {
            img: 'https://imgvid.blob.core.windows.net/imgvid/about.png'
        }
    ]
    aboutContent: Content[] = [
        {
            subTitle: 'Applied Data Science',
            title: 'Industries',
            paragraphText1: 'The key to actionable data science is the speed of execution. The target artifact has to be identified with high accuracy in real time and connected actions should be executed immediately. Our ready to deploy highly efficient models cover typical problems in wide-range of human endeavour.',
            paragraphText2: 'With no-code approach you can add any pre-trained model and tune it to your requirements without writing a single line of code. The tuning can be achieved with as low as a few hundred cases so you can deploy in just a few hours.',
            defaultBtnIcon: 'flaticon-right',
            defaultBtnText: 'Schedule Demo',
            defaultBtnLink: 'about-us-1'
        }
    ]
    featuresList: List[] = [
        {
            icon: 'https://imgvid.blob.core.windows.net/imgvid/icon1.png',
            title: 'Logistics',
            subTitle: 'Goods Movement'
        },
        {
            icon: 'https://imgvid.blob.core.windows.net/imgvid/icon2.png',
            title: 'Warehouse',
            subTitle: 'Inventory Checks'
        },
        {
            icon: 'https://imgvid.blob.core.windows.net/imgvid/icon3.png',
            title: 'Pharma',
            subTitle: 'Packging & Labeling'
        },
        {
            icon: 'https://imgvid.blob.core.windows.net/imgvid/icon4.png',
            title: 'Manufacturing',
            subTitle: 'Defacts Detection'
        },
        {
            icon: 'https://imgvid.blob.core.windows.net/imgvid/icon5.png',
            title: 'HR',
            subTitle: 'Mood & Posture'
        },
        {
            icon: 'https://imgvid.blob.core.windows.net/imgvid/icon6.png',
            title: '+ Add-on',
            subTitle: 'Custom Models'
        }
    ]

}
class Image {
    img : string;
}
class Content {
    subTitle : string;
    title : string;
    paragraphText1 : string;
    paragraphText2 : string;
    defaultBtnIcon : string;
    defaultBtnText : string;
    defaultBtnLink : string;
}
class List {
    icon : string;
    title : string;
    subTitle : string;
} 